module.exports = __webpack_public_path__ + "static/media/p8ru.f043888e.pdf";